import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/tax-planning")({
  head: () => ({
    meta: [
      ...routeMeta("/services/tax-planning"),
      { title: "Tax Planning in Winter Garden, FL | CCOB And Company PA" },
      { name: "description", content: "Year-round tax planning for individuals and business owners — reduce liability, time income and deductions, and avoid year-end surprises." },
      { property: "og:title", content: "Tax Planning — CCOB And Company PA" },
      { property: "og:description", content: "Proactive tax strategy that lowers your bill — legally, and on purpose." },
    ],
    links: canonicalLinks("/services/tax-planning"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Tax Planning"
      title="Plan Your Taxes — Don't Just File Them"
      subtitle="Strategies you act on in March, July, and October — not in April."
      hero={img.heroTax}
      image={img.planning}
      intro="The biggest tax savings come from decisions you make before the year ends — not when the return is due. We meet with you throughout the year to time income, accelerate deductions, and structure transactions so your tax bill reflects intent, not surprise."
      items={[
        { title: "Quarterly Strategy Sessions", desc: "Sit-down reviews to forecast your tax position and adjust withholdings or estimates." },
        { title: "Entity Structure Optimization", desc: "S-Corp salary vs. distribution analysis, LLC elections, and reasonable compensation studies." },
        { title: "Retirement Plan Strategy", desc: "SEP-IRA, Solo 401(k), and defined-benefit plans matched to your business and goals." },
        { title: "Real Estate & Capital Gains", desc: "1031 exchanges, installment sales, depreciation, and timing of dispositions." },
        { title: "Family & Estate Planning", desc: "Hiring children, gifting strategies, and coordinated planning with your estate attorney." },
        { title: "Year-End Tax Projections", desc: "October and December projections so you know your bill before it arrives." },
      ]}
    />
  ),
});
